import {AsideDynamicItemConfigType} from '../app/_metronic/layout/components/aside/aside-menu/aside-menu.component';
import {GET_ALL_ROLES_BY_KEY, ROLE_ADMIN_CENTER, ROLE_PROFESSIONAL, ROLE_SUPER_ADMIN} from './roles';

const ALL_ROLES = GET_ALL_ROLES_BY_KEY('value');

export const ASIDE_CONFIG: AsideDynamicItemConfigType[] = [
  {
    title: 'Dashboard',
    route: '/dashboard',
    pageTitle: 'Dashboard',
    svg: './assets/media/icons/duotune/general/gen025.svg',
    roles: ALL_ROLES
  },
  {
    title: 'PATIENT_MANAGEMENT.LABEL.SINGULAR',
    route: '/management/patient',
    svg: './assets/media/icons/duotune/communication/com013.svg',
    roles: [ROLE_ADMIN_CENTER.value, ROLE_PROFESSIONAL.value]
  },
  {
    title: 'PROFESSIONAL_MANAGEMENT.LABEL.SINGULAR',
    route: '/management/professional',
    svg: './assets/media/icons/duotune/communication/com014.svg',
    roles: [ROLE_SUPER_ADMIN.value, ROLE_ADMIN_CENTER.value]
  },
  {
    title: 'ADMINISTRATOR_CENTER.LABEL.SINGULAR',
    route: '/management/administrator-center',
    svg: './assets/media/icons/duotune/communication/com006.svg',
    roles: [ROLE_SUPER_ADMIN.value]
  },
  {
    header: 'TEXT.ADMINISTRATION',
    roles: [ROLE_SUPER_ADMIN.value]
  },
  // {
  //   title: 'GROUP_MANAGEMENT.LABEL.SINGULAR',
  //   route: '/management/group',
  //   svg: './assets/media/icons/duotune/general/gen051.svg',
  //   roles:[ROLE_ADMIN.value]
  // },
  {
    title: 'CENTER_MANAGEMENT.LABEL.SINGULAR',
    route: '/management/center',
    svg: './assets/media/icons/duotune/general/gen056.svg',
    roles: [ROLE_SUPER_ADMIN.value]
  },
  {
    title: 'USER_MANAGEMENT.LABEL.SINGULAR',
    route: '/management/user',
    svg: './assets/media/icons/duotune/general/gen049.svg',
    roles: [ROLE_SUPER_ADMIN.value]
  },
]
